import { useSelector } from 'react-redux'

import useDrawer from '@/hooks/ui/use-drawer.hook'
import { uiGlobalSelector } from '@/state/ui/global/slices/index.slices'

const useUIFeedback = () => {
  const { drawer } = useSelector(uiGlobalSelector)

  const { handleToggleDrawer } = useDrawer()

  const handleOnCloseDrawer = () => {
    handleToggleDrawer({ open: false, id: '' })
  }

  return {
    handleOnCloseDrawer,
    drawer,
  }
}

export default useUIFeedback
